import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        USER: "",
        LANGUAGE: "en",
        PAGEMAXINDEX: 0,
    },
    mutations: {
        SAVEUSER(state, user) {
            state.USER = user;
            sessionStorage.user = user;
        },
        SAVELANGUAGE(state, language) {
            state.LANGUAGE = language
            localStorage.language = language
        },
        SAVEPAGEMAXINDEX(state, pageMaxIndex) {
            state.PAGEMAXINDEX = pageMaxIndex;
            localStorage.pageMaxIndex = pageMaxIndex;
        },
    },
    actions: {
        SAVEUSER(context, user) {
            context.commit('SAVEUSER', user);
        },
        SAVELANGUAGE(context, language) {
            context.commit("SAVELANGUAGE", language)
        },
        SAVEPAGEMAXINDEX(state, pageMaxIndex) {
            context.commit('SAVEPAGEMAXINDEX', pageMaxIndex);
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js